import { useEffect, useState } from "react";
import { fetcher, getCulture } from "api";
import { useLocation } from "react-router-dom";
import T from "i18n";
import queryString from "query-string";
import globalState from "globalState";
import ReactGA from "react-ga";
import routes from "router/routes";
import GA from "./GA";

export default () => {
  const location = useLocation();
  const state = globalState();
  const [cookieProLoaded, setCookieProLoaded] = useState(false);
  const [cookieProReady, setCookieProReady] = useState(false);

  document.documentElement.setAttribute('lang', getCulture(window.location.pathname.split('/')));
  document.title = T({ path: "metaData.title" });
  document.querySelector('meta[name="description"]').setAttribute("content", T({ path: "metaData.desc" }));
  document.querySelector('meta[property="og:description"]').setAttribute("content", T({ path: "metaData.desc" }));
  document.querySelector('meta[property="og:title"]').setAttribute("content", T({ path: "metaData.title" }));

  function initializeGA() {
    const gaKey = process.env[`REACT_APP_GA_KEY_${state.culture.get().replace('-', '_')}`];
    ReactGA.initialize(gaKey);

    if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${gaKey}"]`)) {
      const scriptTag = document.createElement("script");
      scriptTag.async = true;
      scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${gaKey}`;
      document.head.appendChild(scriptTag);
  
      scriptTag.onload = () => {
        const inlineScript = document.createElement("script");
        inlineScript.textContent = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaKey}');
        `;
        document.head.appendChild(inlineScript);
      };
    }
  }

  function setGAProperties() {
    window.OneTrust?.OnConsentChanged(() => {
      if (window.OnetrustActiveGroups?.split(',').includes('C0002')) {
        initializeGA();
        GA.pageview(window.location.pathname);
      }
    });

    if (window.OnetrustActiveGroups?.split(',').includes('C0002')) {
      initializeGA();
    }
  }

  function waitForOneTrust() {
    if (typeof window.OneTrust !== "undefined") {
      setGAProperties();
      setCookieProReady(true);
    } else {
      setTimeout(waitForOneTrust, 250);
    }
  }

  useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    scriptTag.setAttribute('data-document-language', 'true');
    scriptTag.setAttribute('data-domain-script', process.env.REACT_APP_DOMAIN_SCRIPT_KEY);
    scriptTag.addEventListener('load', () => setCookieProLoaded(true));
    document.head.appendChild(scriptTag);
  }, []);

  useEffect(() => {
    if (!cookieProLoaded) return;
    waitForOneTrust();
  }, [cookieProLoaded]);

  function reloadOTBanner() {
    if (window.OneTrust != null) {
      const toggleDisplay = document.getElementsByClassName("ot-sdk-show-settings");
      for (let i = 0; i < toggleDisplay.length; i += 1) {
        toggleDisplay[i].onclick = function (event) {
          event.stopImmediatePropagation();
          window.OneTrust.ToggleInfoDisplay();
        };
      }
    }
  }

  useEffect(() => {
    fetcher("/api/industrial/families").then((data) => {
      const familyId = data.family_groups[0].id;
      state.familyId.set(familyId);
    });
  }, []);

  useEffect(() => {
    reloadOTBanner();

    const { culture, iframe } = queryString.parse(location.search);
    const newCulture = getCulture(window.location.pathname.split('/'));

    state.culture.set(newCulture || culture || "en-gb");
    state.iframe.set(iframe === "true");

    if (cookieProReady) {
      GA.pageview(location.pathname);
    }

    const onLoad = routes.get(location.pathname)?.onLoad;
    if (onLoad) onLoad();

    document.documentElement.scrollTo(0, 0);
  }, [location.search, location.pathname, cookieProReady]);

  return null;
};
